import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { tokenCreate } from "api/auth";
import useAPICall from "hooks/useAPICall";
import useSnackbarCustom from "hooks/useSnackbarCustom";
import { useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ApiKeyModal = ({ open, onClose }: Props) => {
  const [apiKey, setApiKey] = useState("");
  const { success } = useSnackbarCustom();

  const { callAPI, sending } = useAPICall({
    apiMethod: tokenCreate,
    onSuccess: (res) => {
      setApiKey(res.data.token);
    },
    successMessage: () => "APIキーを発行しました",
    backDrop: true,
  });

  const handleIssue = () => {
    callAPI({});
  };

  const handleCopy = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      success("コピーしました");
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      TransitionProps={{
        onExited: () => setApiKey(""),
      }}
    >
      <DialogTitle>APIキー</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3, mt: 1 }}>
          <Typography variant="body2" color="error" gutterBottom>
            ※発行すると以前発行したAPIキーは無効になります。ご注意ください。
          </Typography>
        </Box>

        {apiKey ? (
          <TextField
            fullWidth
            label="APIキー"
            value={apiKey}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopy} edge="end">
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        ) : (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <Button variant="contained" color="primary" onClick={handleIssue} disabled={sending}>
              APIキーを発行する
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};
